import { eventBus } from "../eventbus.js";

export default {
    data: function () {
        return {
            criteri: {},
            filterPartialRes: [],
            originalFilterPartialRes: [],
            sending: {}
        }
    },
    mounted: function () {
    },
    methods: {
        applyFilter: function(){
            var vm = this,
                valid_criteria = false,
                splitSearchFlag = vm.$root.preferences.splitSearch;
                
            //ciò che viene scritto/spuntato/selezionato negli input del form, viene bindato su filtro tramite v-model
            for(var i = 0; i < this.fields.length; i++){
                var fld = this.fields[i].field;
                if(this.fields[i].type == "select"){
                    //il componente vue select ritorna un oggetto tramite v-model, occore mapparlo nella proprietà interessata al servizio di ricerca
                    var prop = this.fields[i].val_property;
                    if(prop){ // per i menù a tendina 
                        if(this.filtro[fld] != null){
                            //mapping
                            this.sending[fld] = this.filtro[fld][prop];
                        }
                    }
                } else if(this.filtro[fld] != null){ //this.filtro[fld] contiene il valore scritto/spuntato/selezionato nell'input del form
                    this.sending[fld] = this.filtro[fld];
                }
            }

            if(this.sending.ricerca_in_matricola){
                this.sending.ricerca_in_matricola = this.$Jed.firstUpperTranslate('yes')
            }
            if(this.sending.considera_sostitutivi){
                this.sending.considera_sostitutivi = this.$Jed.firstUpperTranslate('yes')
            }
            
            Object.keys(this.sending).some(function(p){ 
                if(p.includes('opa')){
                    vm.sending.opa = vm.sending[p]
                    return true
                }
            })
            //preparo l'oggetto con tutti i criteri di ricerca valorizzati
            this.criteri = {
                mid: this.sending.mat ? this.sending.mat : "",					
                sim: this.sending.ricerca_in_matricola ? this.sending.ricerca_in_matricola : "",			
                id: this.sending.sid ? this.sending.sid : "",						
                des: this.sending.des ? this.sending.des : "",					
                spe: this.sending.spe ? this.sending.spe : "",				
                type: this.sending.prod_type ? this.sending.prod_type : "",				
                not: this.sending.notes ? this.sending.notes : "",		
                opa: this.sending.opa ? this.sending.opa : "",	
                fam: this.sending.fam ? this.sending.fam : "",					
                mod: this.sending.mod ? this.sending.mod : "",
                sost: this.sending.considera_sostitutivi ? this.sending.considera_sostitutivi : ""
            }
            if((this.criteri.des || this.criteri.id) && this.$Behaviors.search.limitSearchForType && this.$Behaviors.search.limitSearchForType!=""){
                this.criteri.type = this.$Behaviors.search.limitSearchForType
            }
            
            if(this.type == 'merchandising')this.criteri.type = 'Modello Abbigliamento'
            if(this.type == 'marketing')this.criteri.type = 'Articoli di stampa'
            if(this.type == 'model')this.criteri.type = 'Modello'

            //se i criteri matricola e ricerca nella matricola sono valorizzati
            //controllo se almeno uno degli altri criteri è valorizzato
            if(this.criteri['sim'] != "" && this.criteri['mid'] != ""){
                var clone = JSON.parse(JSON.stringify(this.criteri))
                delete clone.sim
                delete clone.mid
                var present = Object.values(clone).some(c=>c != "" && c != null && c != 'undefined')
                splitSearchFlag = false;
            }

            if(this.criteri['sim'] != "" && this.criteri['mid'] == ""){  //caso in cui ho spuntato 'ricerca nella matricola' ma non ho inserito la matricola 
                eventBus.$emit('openSearchCriteriaModal', this.$Jed.firstUpperTranslate('insert serial number'));
            }else if(this.criteri['sim'] != "" && this.criteri['mid'] != "" && !present){  //caso in cui ho spuntato 'ricerca nella matricola', ho inserito la matricola ma non ho inserito il criterio con cui cercare dentro la matricola
                eventBus.$emit('openSearchCriteriaModal', this.$Jed.firstUpperTranslate('insert at least one search criterion. Must be at least 4 characters long'));
            }else{
                if(this.type=='criteria'){
                    for(var c in this.criteri){ 
                        if(this.criteri[c] != "" && typeof this.criteri[c] !== typeof true && this.criteri[c].length >= 4){ //se c'è almeno un criterio valorizzato e i caratteri inseriti sono almeno 4
                            valid_criteria = true;
                            break
                        }
                    } 
                    //nascondo la tabella con i risultati precedenti
                    eventBus.$emit('hideTable');
                }else{
                    for(var c in this.criteri){ 
                        if(this.criteri[c] != ""){ //se c'è almeno un criterio valorizzato
                            valid_criteria = true;
                            break
                        }
                    }
                    //nascondo la tabella con i risultati precedenti
                    eventBus.$emit('hideTable'); 
                }
                
                var vm = this, modello_matricola = null;
                if(valid_criteria){
                    console.log('valid criteria')
                    if(this.type=='criteria'){
                        if(!this.$Behaviors.search.formAlwaysOpened){
                            this.expandSearch = false; //collasso il form
                            this.angleIcon = this.$root.icons.expandForm;//this.angleIcon = this.$root.icons.compressForm;
                        }
                    }

                    //FACCIO LA RICHIESTA AL CMD DI RICERCA 
                    vm.$root.microservice({
                        "role": "search",
                        "cmd": "GetProdByCriteria",
                        "params": {
                            "criteri": this.criteri,
                            "lang": vm.$root.token.siglaLingua,
                            "defLang": vm.$root.token.defaultLang,
                            "root": vm.$root.index_as_root,
                            "split": splitSearchFlag,
                            "caller": "stdSearch"
                        }
                    })
                    .then((response) => { 
                        if(response && response.body && response.body.errorMsg){
                            vm.filterPartialRes = []
                            vm.filtered = []
                            if(vm.type=='criteria')eventBus.$emit('no_search_results');
                            if(vm.type=='model')eventBus.$emit('no_model_results');
                            if(vm.type=='marketing')eventBus.$emit('no_mark_results');
                            if(vm.type=='merchandising')eventBus.$emit('no_merch_results');
                            eventBus.$emit('alert', {
                                message: vm.$Jed.firstUpperTranslate("Request timed out. Try to do a more specific search.", null), 
                                type: "warning",
                                action: ''
                            })
                        } else if(response){
                            vm.maxRes = response.body[response.body.length-1] //l'ultimo elemento dell'array indica il numero massimo di risultati che ho scelto di considerare
                            response.body.pop() //rimuovo l'ultimo elemento perchè non è un risultato 
                            if(response.body.length>0 && vm.criteri['mid'] != ""){
                                modello_matricola = response.body[response.body.length-1] //il penultimo elemento dell'array indica se è stato trovato o no il modello
                                response.body.pop() //rimuovo l'ultimo elemento perchè non è un risultato 
                            }
                            if (response.body.length>0) {
                                var tableData = []
                                vm.filterPartialRes = []

                                for(var e in response.body){
                                    var elem = response.body[e]
                                   
                                    if(this.type=='criteria'){
                                        tableData.push({
                                            typ: elem.typ,
                                            id: elem.spo || elem.spi ? elem.spi : elem.id ? elem.id : elem.sid, //nel caso in cui sia un nodo uso sid
                                            spi: elem.spo || elem.spi ? elem.id : elem.newId, //se c'è l'id/record vecchio, nel campo "sostitutivo" metto id (è l'id del sostitutivo)
                                            des: elem.spo ? elem.spo.des : elem.des ? elem.des : elem.not,
                                            fathers: elem.fathers,
                                            gra: elem.gra
                                        })

                                        //popolo la tabella con i risultati della ricerca
                                        eventBus.$emit('tableData', tableData, 'criteria')
            
                                        //la rendo visibile
                                        if(vm.criteri['mid'] != "" && modello_matricola){
                                            eventBus.$emit('tableVisible', vm.sending, vm.maxRes, 'criteria', modello_matricola);
                                        }else{
                                            eventBus.$emit('tableVisible', vm.sending, vm.maxRes, 'criteria');
                                        }
                                        
                                    }else{
                                        eventBus.$emit('search_done')
                                        
                                        if(!vm.filterPartialRes.includes(elem))vm.filterPartialRes.push(elem) //preparo l'array con i risultati del primo filtraggio
                                        
                                        this.filtered = vm.filterPartialRes;
                                        
                                        for (let i = 0; i < elem.att.length; i++) {
                                            var attr = this.attributesColl.find({id: elem.att[i]})[0]
                                            var typ = attr.cat //categoria dell'attributo
                                            var val = attr.nam[vm.cur_lang] ? attr.nam[vm.cur_lang] : attr.nam[vm.$root.token.defaultLang]//valore da mettere nella tendina
                                            var v = {
                                                id: attr.id,
                                                type: val
                                            }
                                            for(var f in vm.fields){
                                                if(vm.fields[f].label.toLowerCase() == typ.toLowerCase()){
                                                    if(!vm.fields[f].choices.some((c)=>{return c.id == v.id}))vm.fields[f].choices.push(v) //metto nei dropdown i risultati distinct
                                                }
                                            }
                                            //...e riabilito le tendine
                                            for(var f in vm.fields){
                                                this.disableSelectInput[vm.fields[f].field] = false 
                                            }
                                        }
                                    } 
                                } 
                                this.originalFilterPartialRes = this.filterPartialRes.slice();
                            }else{
                                console.log("no results from catalog")
                                this.filterPartialRes = []
                                this.filtered = []
                                if(this.type=='criteria')eventBus.$emit('no_search_results');
                                if(this.type=='model')eventBus.$emit('no_model_results');
                                if(this.type=='marketing')eventBus.$emit('no_mark_results');
                                if(this.type=='merchandising')eventBus.$emit('no_merch_results');
                            }
                        }else{
                            console.log("no results from catalog")
                            if(this.type=='criteria')eventBus.$emit('no_search_results');
                            if(this.type=='model')eventBus.$emit('no_model_results');
                            if(this.type=='marketing')eventBus.$emit('no_mark_results');
                            if(this.type=='merchandising')eventBus.$emit('no_merch_results');
                        }
                    }, err=>{
                        if(this.type=='criteria')eventBus.$emit('no_search_results');
                        if(this.type=='model')eventBus.$emit('no_model_results');
                        if(this.type=='marketing')eventBus.$emit('no_mark_results');
                        if(this.type=='merchandising')eventBus.$emit('no_merch_results');
                        console.log(err)
                        //vedi gestione errore in main.js > microservice
                    })
                    .catch(err => {
                        console.log(err);
                        var msg = err && err.body && err.body.error ? err.body.error : ''
                        if(this.type=='criteria')eventBus.$emit('no_search_results');
                        if(this.type=='model')eventBus.$emit('no_model_results');
                        if(this.type=='marketing')eventBus.$emit('no_mark_results');
                        if(this.type=='merchandising')eventBus.$emit('no_merch_results');
                        eventBus.$emit('alert', {
                            message: "Application caught an error <br> <h5>Details: " + "search.GetProdByCriteria - " + msg +'</h5>',
                            type: "error",
                            action: ''
                        })
                    })				  
                }else{
                    if(this.type=='criteria')eventBus.$emit('no_search_results');//nasconde il waiter
                    eventBus.$emit('openSearchCriteriaModal', vm.$Jed.firstUpperTranslate('insert at least one search criterion. Must be at least 4 characters long'));
                }
            }
        },
        showResults: function(){
            var alertToFill = [] //contiene i nomi dei campi che sono obbligatori ma che non sono stati valorizzati
            
            for(var f in this.filtro){
                for(var i in this.fields){
                    if((f == this.fields[i].field && this.fields[i].mandatory && this.filtro[f]=="") || !this.filtro.hasOwnProperty(this.fields[i].field)){ //se un campo in fields è obbligatorio, ma non è stato valorizzato nel filtro
                        if(!alertToFill.includes(" "+this.fields[i].label.toLowerCase())){alertToFill.push(" "+this.fields[i].label.toLowerCase())}
                    }
                }
            }
            
            if(alertToFill.length>0){
                eventBus.$emit('openSearchCriteriaModal', this.$Jed.firstUpperTranslate('insert')+alertToFill);
            }else{
                if(!this.$Behaviors.search.formAlwaysOpened){
                    this.expandSearch = false; //collasso il form
                    this.angleIcon = this.$root.icons.expandForm;//this.angleIcon = this.$root.icons.compressForm;
                }                
                if(this.fields.length==1){ //se c'è solo un campo, non devo scegliere da altri menù a tendina e mostro subito i risultati del primo filtro
                    //popolo la tabella con i risultati della ricerca
                    eventBus.$emit('tableData', this.filterPartialRes, 'mkting')
                    
                    //la rendo visibile
                    eventBus.$emit('tableVisible', this.sending, this.maxRes, 'mkting');
                    this.filterPartialRes = this.originalFilterPartialRes;
                }else{
                    if(this.type=='model'){
                        //popolo la tabella con i risultati della ricerca
                        eventBus.$emit('tableData', this.filtered, 'model')
                        
                        //la rendo visibile
                        eventBus.$emit('tableVisible', this.sending, this.maxRes, 'model');
                        this.filterPartialRes = this.originalFilterPartialRes;
                    }else if(this.type=='merchandising'){
                        //popolo la tabella con i risultati della ricerca
                        eventBus.$emit('tableData', this.filtered, 'merchandising')
                        
                        //la rendo visibile
                        eventBus.$emit('tableVisible', this.sending, this.maxRes, 'merchandising');
                        this.filterPartialRes = this.originalFilterPartialRes;
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/search_mixin.js